class Copy {
  constructor(el) {
    this.button = el;
    this.tooltip = el.querySelector('.copy__tooltip');
    this.copyText = el.dataset.copylink;
    this.copiedText = el.dataset.copied;
    this.copyType = el.dataset.copytype;
    this.timer;

    this.tooltip.textContent = this.copyText;

    el.addEventListener('click', () => {
      this.onCopy();
    });

    el.addEventListener('mouseenter', () => {
      this.button.classList.add('copy--hover');
    });

    el.addEventListener('mouseleave', () => {
      this.button.classList.remove('copy--hover');
    });
  }

  valueToCopy() {
    let url = document.location.href;

    if (this.copyType === 'hash') {
      const hash = this.button.getAttribute('aria-labelledby').split('copy-tooltip-')[1];
      url = `${document.location.origin}${document.location.pathname}#${hash}`;
    }

    return url;
  }

  onCopy() {
    const textarea = document.createElement('textarea');
    clearTimeout(this.timer);

    textarea.id = 'copy__textarea';
    textarea.value = this.valueToCopy();
    textarea.setAttribute('readonly', '');

    document.body.append(textarea);
    textarea.select();
    textarea.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.button.focus();

    this.tooltip.textContent = this.copiedText;
    this.timer = setTimeout(() => {
      this.button.blur();
      this.button.classList.remove('copy--hover');

      setTimeout(() => {
        this.tooltip.textContent = this.copyText;
      }, 300);
    }, 1500);
  }
}

const init = () => {
  [...document.querySelectorAll('.js-copy')].forEach((el) => new Copy(el));
};

export { init };
